var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    id: "i-419",
    d: "M46.557,37.182l-9-6.014c-1.498-1.002-2.941-0.967-4.189,0.059c-3.504,2.873-5.582,2.049-5.92,1.879 c-1.982-0.992-3.854-1.928-6.741-4.813c-3.584-3.586-4.878-5.875-5.812-7.74c-0.373-0.746-0.803-3.254,1.65-5.869 c1.147-1.221,1.253-2.721,0.299-4.221c-0.735-1.156-0.735-1.156-1.313-2.006c-0.57-0.84-1.709-2.518-4.713-7.014 C10.169,0.473,9.247,0,8,0C6.586,0,5.87,0.717,5.293,1.293l-3,3C0.169,6.416,0,7.633,0,9c0,1.721,2.485,12.939,14.292,24.705 C26.061,45.514,37.268,48,38.988,48h0.066c1.355-0.02,2.559-0.199,4.652-2.293l3-3C47.283,42.131,48,41.414,48,40 C48,38.752,47.527,37.83,46.557,37.182z M45.293,41.293l-3,3c-1.684,1.684-2.416,1.695-3.305,1.707 c-0.123-0.004-10.891-1.273-23.282-13.709C3.415,20.043,2.002,9.096,2,9c0-0.887,0-1.586,1.706-3.293l3-3C7.233,2.182,7.443,2,8,2 c0.653,0,0.927,0.213,1.156,0.555c3.009,4.504,4.15,6.186,4.721,7.025c0.563,0.828,0.563,0.828,1.28,1.957 c0.568,0.893,0.302,1.383-0.07,1.779c-3.121,3.324-2.66,6.771-1.981,8.131c1.003,2.006,2.39,4.463,6.187,8.26 c3.115,3.115,5.223,4.168,7.26,5.188c0.561,0.279,1.293,0.434,2.063,0.434c1.326,0,3.445-0.443,6.02-2.555 c0.365-0.301,0.625-0.336,0.789-0.336c0.287,0,0.631,0.133,1.021,0.395l9,6.012C45.787,39.072,46,39.346,46,40 C46,40.557,45.818,40.768,45.293,41.293z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-419"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.fc7195139d684fa2f6bb03b8b9816095.svg";
export { ForwardRef as ReactComponent };